var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "b-dropdown",
        {
          staticClass: "p-0",
          attrs: {
            id: "dropdown-1",
            variant: "outline-success",
            text: "Dropdown Button",
            "no-caret": "",
          },
          scopedSlots: _vm._u([
            {
              key: "button-content",
              fn: function () {
                return [
                  _c(
                    "a",
                    {
                      staticClass: "header-icon",
                      attrs: {
                        href: "#",
                        "data-toggle": "dropdown",
                        title: "You got 11 notifications",
                      },
                    },
                    [_c("i", { staticClass: "fal fa-bell" })]
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _vm._v(" "),
          _c("b-dropdown-form", { staticClass: "notif_user" }, [
            _c("div", { staticClass: "dropdown-xl" }, [
              _c(
                "div",
                {
                  staticClass:
                    "dropdown-header bg-trans-gradient d-flex justify-content-center align-items-center rounded-top mb-2",
                },
                [
                  _c("h4", { staticClass: "m-0 text-center color-white" }, [
                    _vm._v(
                      "\n                        Повідомлення\n                    "
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "ul",
                {
                  staticClass: "nav nav-tabs nav-tabs-clean",
                  attrs: { role: "tablist" },
                },
                _vm._l(_vm.tabs, function (tab) {
                  return _c("li", { staticClass: "nav-item" }, [
                    _c(
                      "a",
                      {
                        staticClass: "nav-link px-4 fs-md js-waves-on fw-400",
                        attrs: { "data-toggle": "tab" },
                        on: {
                          click: function ($event) {
                            return _vm.activate_tab(tab)
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n                           " +
                            _vm._s(tab.name) +
                            "\n                        "
                        ),
                      ]
                    ),
                  ])
                }),
                0
              ),
              _vm._v(" "),
              _c("div", { staticClass: "tab-content tab-notification" }, [
                _vm.is_active_empty
                  ? _c(
                      "div",
                      {
                        staticClass: "tab-pane p-3 text-center",
                        class: { active: _vm.is_active_empty },
                      },
                      [
                        _c("h5", { staticClass: "mt-4 pt-4 fw-500" }, [
                          _c(
                            "span",
                            { staticClass: "d-block fa-3x pb-4 text-muted" },
                            [
                              _c("i", {
                                staticClass:
                                  "ni ni-arrow-up text-gradient opacity-70",
                              }),
                            ]
                          ),
                          _vm._v(
                            "Оберіть таб для відображення\n                            "
                          ),
                          _c(
                            "small",
                            { staticClass: "mt-3 fs-b fw-400 text-muted" },
                            [
                              _vm._v(
                                "\n                                Тут Ви маєте можливість переглянути Дні народження співробітників поточно місяця, та переглянути повідомлення\n                            "
                              ),
                            ]
                          ),
                        ]),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                !_vm.is_active_empty
                  ? _c(
                      "div",
                      {
                        staticClass: "tab-pane",
                        class: { active: !_vm.is_active_empty },
                        attrs: { id: "tab-messages", role: "tabpanel" },
                      },
                      [
                        _vm.active_tab.type == "message"
                          ? _c("message")
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.active_tab.type == "feed" ? _c("feed") : _vm._e(),
                        _vm._v(" "),
                        _vm.active_tab.type == "birthday"
                          ? _c("birthday")
                          : _vm._e(),
                      ],
                      1
                    )
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "py-2 px-3 bg-faded d-block rounded-bottom text-right border-faded border-bottom-0 border-right-0 border-left-0",
                },
                [
                  _c(
                    "a",
                    {
                      staticClass: "fs-xs fw-500 ml-auto",
                      attrs: { href: "/profile" },
                    },
                    [_vm._v("Перейти до кабінету")]
                  ),
                ]
              ),
            ]),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }